import axios from "axios";
import configuration from "../configuration/configuration";
import {default as i18n} from "i18next";

export default class AuthAPI {


    loginUrl(url) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios({
                    method: 'post',
                    url: `${configuration.API}/api/loginUrl`,
                    headers: {
                        'content-type': 'application/json'
                    },
                    data: {
                        url
                    }
                });
                resolve({token: response.data.token, data: response.data})
            } catch (error) {
                reject(i18n.t('errors.login-fail'))
            }
        })
    }

    login(email, password) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios({
                    method: 'post',
                    url: `${configuration.API}/api/login`,
                    headers: {
                        'content-type': 'application/json'
                    },
                    data: {
                        email,
                        password
                    }
                });
                resolve({token: response.data.token, data: response.data})
            } catch (error) {
                reject(i18n.t('errors.login-fail'))
            }
        })
    }

    updateLogo(datas) {
        return new Promise(async(resolve, reject) => {
            try {
                const data = new FormData();

                if (datas.file) {
                    data.append('file', datas.file)
                }

                data.append('data', JSON.stringify(datas.file));

                const response = await axios({
                    method: 'POST',
                    url: `${configuration.API}/api/logo`,
                    headers: {
                        'content-type': 'multipart/form-data'
                    },
                    data
                });

                resolve(response.data)
            } catch (error) {
                reject(error)
            }
        })
    }


    updateSidebar(datas) {
        return new Promise(async(resolve, reject) => {
            try {
                const data = new FormData();
                if (datas.file) {
                    data.append('file', datas.file)
                }
                data.append('data', JSON.stringify(datas.file));

                const response = await axios({
                    method: 'POST',
                    url: `${configuration.API}/api/sidebar`,
                    headers: {
                        'content-type': 'multipart/form-data'
                    },
                    data
                });

                resolve(response.data)
            } catch (error) {
                reject(error)
            }
        })
    }


    async updateDetails(data) {
        return new Promise(async (resolve, reject) => {

            try {
                const response = await axios({
                    method: 'put',
                    url: `${configuration.API}/api/details`,
                    headers: {
                        'content-type': 'application/json'
                    },
                    data: data
                });
                resolve(response.data)
            } catch (error) {
                reject(i18n.t('errors.login-fail'))
            }
        })
    }

    /** Enregistre le diaporama du mode Publicité (liste complète des diapositives). */
    async updatePublicite(diapositives) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios({
                    method: 'put',
                    url: `${configuration.API}/api/publicite`,
                    headers: {'content-type': 'application/json'},
                    data: {diapositives}
                });
                resolve(response.data)
            } catch (error) {
                reject(error?.response?.data?.message || i18n.t('errors.login-fail'))
            }
        })
    }

    /** Vidéos de la galerie, pour le diaporama du mode Publicité : [{id, nom, url}]. */
    async getVideosPublicite() {
        const response = await axios({method: 'get', url: `${configuration.API}/api/publicite/videos`});
        return response.data
    }

    /**
     * Ajoute une vidéo (MP4 ou WebM) à la galerie ; `progression` reçoit le pourcentage envoyé.
     * La vidéo part en morceaux de 1 Mo, l'un après l'autre : l'envoi ne dépend ni de la limite de taille d'envoi du serveur
     * (PHP, Apache), ni de la durée d'un gros envoi. Un morceau qui échoue (réseau) est renvoyé jusqu'à 3 fois.
     */
    async ajouterVideoPublicite(fichier, progression) {
        const TAILLE = 1024 * 1024;
        const total = Math.max(1, Math.ceil(fichier.size / TAILLE));
        const envoi = Array.from(crypto.getRandomValues(new Uint8Array(16))).map(o => o.toString(16).padStart(2, "0")).join("");
        let reponse = null;
        for (let index = 0; index < total; index++) {
            const data = new FormData();
            data.append('envoi', envoi);
            data.append('index', index);
            data.append('total', total);
            data.append('nom', fichier.name);
            data.append('morceau', fichier.slice(index * TAILLE, (index + 1) * TAILLE), 'morceau.bin');
            reponse = await this.envoyerMorceauVideo(data);
            if (progression) progression(Math.round((index + 1) * 100 / total));
        }
        return reponse
    }

    async envoyerMorceauVideo(data) {
        for (let essai = 1; ; essai++) {
            try {
                const response = await axios({
                    method: 'post',
                    url: `${configuration.API}/api/publicite/videos/morceau`,
                    headers: {'content-type': 'multipart/form-data'},
                    data,
                });
                return response.data
            } catch (error) {
                const reponse = error?.response;
                // sans réponse du serveur (réseau, coupure) ou erreur du serveur : on réessaie ; une erreur de validation est définitive
                if ((!reponse || reponse.status >= 500) && essai < 3) {
                    await new Promise(r => setTimeout(r, 1000 * essai));
                    continue;
                }
                const erreurs = reponse?.data?.errors;
                const premiere = erreurs && Object.values(erreurs)[0] && Object.values(erreurs)[0][0];
                if (!reponse) throw "Envoi interrompu : le réseau ou le serveur a coupé la connexion à plusieurs reprises.";
                throw premiere || reponse.data?.message || `Vidéo refusée par le serveur (code ${reponse.status})`;
            }
        }
    }

    /** Associe une image de la galerie à un fond du bandeau (images de manettes du fond « manettes »). */
    async addFondImage(fond, assetId) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios({
                    method: 'post',
                    url: `${configuration.API}/api/fond/images`,
                    headers: {'content-type': 'application/json'},
                    data: {fond, asset_id: assetId}
                });
                resolve(response.data)
            } catch (error) {
                reject(error?.response?.data?.message || i18n.t('errors.login-fail'))
            }
        })
    }

    /** Enregistre les réglages d'un fond (valeurs modifiées seulement) ; null : retour aux valeurs d'origine. */
    async updateFondReglages(fond, reglages) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios({
                    method: 'put',
                    url: `${configuration.API}/api/fond/reglages`,
                    headers: {'content-type': 'application/json'},
                    data: {fond, reglages}
                });
                resolve(response.data)
            } catch (error) {
                reject(error?.response?.data?.message || i18n.t('errors.login-fail'))
            }
        })
    }

    /** Enregistre les fonds retirés de la rotation automatique (liste vide : tous y sont). */
    async updateFondRotation(exclus) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios({
                    method: 'put',
                    url: `${configuration.API}/api/fond/rotation`,
                    headers: {'content-type': 'application/json'},
                    data: {exclus}
                });
                resolve(response.data)
            } catch (error) {
                reject(error?.response?.data?.message || i18n.t('errors.login-fail'))
            }
        })
    }

    /** Retire une image d'un fond du bandeau (elle reste dans la galerie). */
    async removeFondImage(id) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios({
                    method: 'delete',
                    url: `${configuration.API}/api/fond/images/${id}`,
                    headers: {'content-type': 'application/json'}
                });
                resolve(response.data)
            } catch (error) {
                reject(i18n.t('errors.login-fail'))
            }
        })
    }

    /** Choix manuel du fond du bandeau d'Aerith ; fond = null pour revenir tout de suite à la rotation automatique. */
    async updateFond(fond) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios({
                    method: 'put',
                    url: `${configuration.API}/api/fond`,
                    headers: {
                        'content-type': 'application/json'
                    },
                    data: {fond}
                });
                resolve(response.data)
            } catch (error) {
                reject(i18n.t('errors.login-fail'))
            }
        })
    }

    async checkIsLoged(token) {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios({
                    method: 'post',
                    url: `${configuration.API}/api/details`,
                    headers: {
                        'content-type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                });

                resolve({token: token, data: response.data });

            } catch (error) {
                reject('')
            }
        })
    }

    async refreshToken() {
        return new Promise(async (resolve, reject) => {
            try {
                const response = await axios({
                    method: 'get',
                    url: `${configuration.API}/api/refreshToken`,
                    headers: {
                        'content-type': 'application/json'
                    }
                });

                resolve({token: response.data.token, data: response.data})
            } catch (error) {
                reject('')
            }
        })
    }
}